var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#FF6019"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2505_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5007 19.6667L23.0007 17.1667H17.1673C16.9463 17.1667 16.7343 17.0789 16.5781 16.9226C16.4218 16.7663 16.334 16.5543 16.334 16.3333V11.3333C16.334 11.1123 16.4218 10.9004 16.5781 10.7441C16.7343 10.5878 16.9463 10.5 17.1673 10.5H24.6673C24.8883 10.5 25.1003 10.5878 25.2566 10.7441C25.4129 10.9004 25.5007 11.1123 25.5007 11.3333V19.6667Z",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 20V22.1663C19.6667 22.3874 19.5789 22.5993 19.4226 22.7556C19.2663 22.9119 19.0543 22.9997 18.8333 22.9997H13L10.5 25.4997V17.1663C10.5 16.9453 10.5878 16.7334 10.7441 16.5771C10.9004 16.4208 11.1123 16.333 11.3333 16.333H13.5",
    stroke: "#FF6019",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2505_1471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerMsg);
export default __webpack_public_path__ + "static/media/CustomerMsg.7a85bd5f.svg";
export { ForwardRef as ReactComponent };